module.exports = __webpack_public_path__ + "static/media/successful1_mobile.0815aa93.png";